import {list, createDirect} from "../../api/methods/rooms";
import ChatTypes from "../../enums/ChatTypes";
import NewRoom from '../../models/Rooms/NewRoom';

export default {
    async fetchData({commit, dispatch, rootState}) {
        try {
            const userGroupIds = rootState.session.profile?.groupIds ?? [];
            const urlParams = new URLSearchParams({
                take: -1,
                isMember: false,
                count: true
            });
            userGroupIds.forEach((item) => {
                urlParams.append('groupIds', item);
            })
            const data = await list(urlParams);
            const groups = data.filter(item => item.type == ChatTypes.publicGroup) || [],
                  channels = data.filter(item => item.type == ChatTypes.channel) || [];
            commit('setGroups', groups);
            commit('setChannels', channels);
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
        }
    },
    async createPrivateGroup({ commit, state, dispatch, rootState }, { title, membersUserIds }) {
        try {

            const newGroup = NewRoom.getPrivateGroup(membersUserIds, title);
            const group = await createDirect(newGroup);
            const rooms = rootState.chat.rooms.list;

            rooms.push(group);
            return group;
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
            return null;
        }
    },
    removeFromAvailable({commit, state}, id) {
        const newGroups = state.groups.filter(item => item.id != id),
            newChannels = state.channels.filter(item => item.id != id);
        commit('setGroups', newGroups);
        commit('setChannels', newChannels);
    }
}